// eslint-disable-next-line no-unused-vars
import React from 'react';
var activities = function activities(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M36.827 32.21l6.179 1.912 6.163-1.912 1.43 6.336 4.749 4.409-4.748 4.409-1.431 6.336-6.163-1.912-6.179 1.912-1.43-6.337-4.749-4.408 4.749-4.409 1.43-6.336z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.997 30l4.586 4.997L54.16 36.5 52.168 43l1.992 6.5L47.583 51l-4.586 4.998L38.412 51l-6.592-1.502 2.006-6.5L31.82 36.5l6.592-1.502L42.997 30z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "42.934",
    cy: "42.935",
    r: "6.825",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.117 42.935a6.812 6.812 0 0 0 6.819 6.819 6.82 6.82 0 0 0 6.819-6.819 6.812 6.812 0 0 0-6.82-6.819 6.812 6.812 0 0 0-6.818 6.819zm-.396 0a7.208 7.208 0 0 0 7.215 7.215 7.216 7.216 0 0 0 7.215-7.215 7.208 7.208 0 0 0-7.215-7.215 7.208 7.208 0 0 0-7.215 7.215z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.325 47.225v-8.45l-7.34-4.225-7.338 4.225v8.45l7.339 4.225 7.339-4.225z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M36.028 1.358a54.538 54.538 0 0 1 13.944 0c2.438.307 4.347 2.233 4.67 4.67a54.54 54.54 0 0 1 0 13.944c-.306 2.438-2.232 4.347-4.67 4.67a54.53 54.53 0 0 1-13.944 0c-2.437-.306-4.346-2.232-4.67-4.67a54.54 54.54 0 0 1 0-13.943c.323-2.438 2.233-4.364 4.67-4.671z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M43 22.75A9.74 9.74 0 0 1 33.25 13 9.74 9.74 0 0 1 43 3.25 9.74 9.74 0 0 1 52.75 13 9.74 9.74 0 0 1 43 22.75z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.272 49.5v-13L12.98 30 1.688 36.5v13L12.98 56l11.292-6.5z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M13 52.1A9.091 9.091 0 0 1 3.9 43c0-5.033 4.068-9.1 9.1-9.1 5.033 0 9.1 4.067 9.1 9.1 0 5.033-4.067 9.1-9.1 9.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 43c0 4.756 3.843 8.6 8.6 8.6 4.742 0 8.601-3.844 8.601-8.6s-3.843-8.6-8.6-8.6A8.592 8.592 0 0 0 4.4 43zm-.5 0c0 5.033 4.068 9.1 9.1 9.1 5.017 0 9.1-4.067 9.1-9.1 0-5.033-4.067-9.1-9.1-9.1A9.091 9.091 0 0 0 3.9 43z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M12.983 25.123c-6.67 0-12.09-5.405-12.09-12.09S6.313.943 12.983.943c6.685 0 12.09 5.42 12.09 12.09.015 6.685-5.405 12.09-12.09 12.09z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.982 22.783c-5.375 0-9.75-4.358-9.75-9.75a9.74 9.74 0 0 1 9.75-9.75 9.74 9.74 0 0 1 9.75 9.75 9.74 9.74 0 0 1-9.75 9.75z",
    fill: "#FF8BAE"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  }))));
};
activities.defaultProps = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var activityStepCompleted = function activityStepCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20.484",
    r: "20",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.297 25.911l-4.97-4.969.478-.478 4.492 4.492 9.898-9.898.478.478L17.297 25.91z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.297 26.479l-5.537-5.537 1.045-1.045 4.492 4.491 9.898-9.898 1.045 1.046-10.943 10.943zm0-1.523l-4.492-4.492-.478.478 4.97 4.97 10.376-10.376-.478-.478-9.898 9.898z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.297 26.479l-5.537-5.537 1.045-1.045 4.492 4.491 9.898-9.898 1.045 1.046-10.943 10.943zm0-3.226l9.898-9.898 2.18 2.18-12.078 12.079-6.672-6.672 2.18-2.18 4.492 4.491z",
    fill: "#fff"
  }));
};
activityStepCompleted.defaultProps = {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var dropbox = function dropbox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0L0 8.263l12 8.142 12-8.142L12 0zm24 0L24 8.263l12 8.142 12-8.142L36 0zM0 24.668l12 8.264 12-8.264-12-8.263-12 8.263zm36-8.263l-12 8.263 12 8.264 12-8.264-12-8.263zm-24 19.2l12 8.263 12-8.263-12-8.142-12 8.142z",
    fill: "#0062FF"
  }));
};
dropbox.defaultProps = {
  width: "48",
  height: "44",
  viewBox: "0 0 48 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var googleDoc = function googleDoc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M44.545 56h-33.09a3.83 3.83 0 0 1-3.819-3.818V3.818A3.83 3.83 0 0 1 11.454 0h22.91l14 14v38.182A3.83 3.83 0 0 1 44.545 56z",
    fill: "#3086F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.364 0l14 14h-14V0z",
    fill: "#0C67D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.455 24.818h-22.91v-3.182h22.91v3.182zm0 4.455h-22.91v3.182h22.91v-3.182zm-6.364 7.636H16.545v3.182h16.546v-3.182z",
    fill: "#FDFFFF"
  }));
};
googleDoc.defaultProps = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var googleCalendar = function googleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M93.78 29.1H29.1v64.68h64.68V29.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.78 122.88l29.1-29.1h-29.1v29.1z",
    fill: "#f72a25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88 29.1h-29.1v64.68h29.1V29.1z",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.78 93.78H29.1v29.1h64.68v-29.1z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 93.78v19.4c0 5.36 4.34 9.7 9.7 9.7h19.4v-29.1H0z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88 29.1V9.7c0-5.36-4.34-9.7-9.7-9.7h-19.4v29.1h29.1z",
    fill: "#1967d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.78 0H9.7C4.34 0 0 4.34 0 9.7v84.08h29.1V29.1h64.67V0h.01z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.37 79.27c-2.42-1.63-4.09-4.02-5-7.17l5.61-2.31c.51 1.94 1.4 3.44 2.67 4.51 1.26 1.07 2.8 1.59 4.59 1.59 1.84 0 3.41-.56 4.73-1.67 1.32-1.12 1.98-2.54 1.98-4.26 0-1.76-.7-3.2-2.09-4.32s-3.14-1.67-5.22-1.67H46.4v-5.55h2.91c1.79 0 3.31-.48 4.54-1.46 1.23-.97 1.84-2.3 1.84-3.99 0-1.5-.55-2.7-1.65-3.6s-2.49-1.35-4.18-1.35c-1.65 0-2.96.44-3.93 1.32-.97.88-1.7 2-2.12 3.24l-5.55-2.31c.74-2.09 2.09-3.93 4.07-5.52 1.98-1.59 4.51-2.39 7.58-2.39 2.27 0 4.32.44 6.13 1.32 1.81.88 3.23 2.1 4.26 3.65 1.03 1.56 1.54 3.31 1.54 5.25 0 1.98-.48 3.65-1.43 5.03-.95 1.37-2.13 2.43-3.52 3.16v.33c1.79.74 3.36 1.96 4.51 3.52 1.17 1.58 1.76 3.46 1.76 5.66s-.56 4.16-1.67 5.88c-1.12 1.72-2.66 3.08-4.62 4.07-1.96.99-4.17 1.49-6.62 1.49-2.84 0-5.46-.81-7.88-2.45zm34.46-27.84l-6.16 4.45-3.08-4.67 11.05-7.97h4.24v37.6h-6.05V51.43z",
    fill: "#1a73e8"
  }));
};
googleCalendar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 122.88 122.88"
};
var linkedinNegative = function linkedinNegative(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.486 3.268a2.069 2.069 0 0 1 0 4.137 2.068 2.068 0 0 1 0-4.137zM3.7 20.456h3.568V8.976H3.701v11.48zM9.504 8.975h3.416v1.568h.05c.475-.902 1.637-1.854 3.371-1.854 3.606 0 4.272 2.378 4.272 5.47v6.297h-3.56v-5.582c0-1.333-.026-3.045-1.852-3.045-1.854 0-2.137 1.45-2.137 2.947v5.68h-3.56V8.976z",
    fill: "#2867B2"
  }));
};
linkedinNegative.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var miro = function miro(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0V0z",
    fill: "#FFD02F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.708 6.4h-5.124l4.549 7.05-9.617-7.05h-5.124l4.549 9.238L12.324 6.4H7.2l4.474 11.926L7.2 41.6h5.124l9.617-24.955L17.392 41.6h5.124l9.617-27.142L27.584 41.6h5.124L42.4 11.785 32.708 6.4z",
    fill: "#050038"
  }));
};
miro.defaultProps = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var notion = function notion(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9 9.24c1.485 1.207 2.042 1.115 4.83.93l26.295-1.58c.557 0 .094-.556-.092-.649l-4.367-3.156c-.837-.65-1.952-1.394-4.088-1.208L5.018 5.434c-.93.092-1.115.556-.745.929L7.9 9.24zm1.578 6.128v27.666c0 1.487.743 2.043 2.415 1.951l28.897-1.672c1.673-.092 1.86-1.114 1.86-2.322V13.51c0-1.206-.464-1.857-1.488-1.764l-30.198 1.764c-1.114.093-1.486.65-1.486 1.857zm28.527 1.484c.185.837 0 1.672-.838 1.766l-1.392.278V39.32c-1.21.65-2.324 1.02-3.253 1.02-1.487 0-1.86-.464-2.973-1.856L20.44 24.188V38.02l2.882.65s0 1.67-2.325 1.67l-6.41.373c-.186-.372 0-1.3.65-1.486l1.673-.463v-18.29l-2.322-.187c-.187-.836.277-2.042 1.579-2.135l6.876-.464 9.478 14.483V19.36l-2.416-.277c-.186-1.023.556-1.765 1.486-1.857l6.413-.374zM2.88 2.928L29.363.978c3.252-.28 4.089-.093 6.133 1.392l8.453 5.942c1.395 1.021 1.86 1.3 1.86 2.413v32.588c0 2.042-.744 3.25-3.345 3.435l-30.755 1.857c-1.952.093-2.882-.185-3.904-1.485l-6.226-8.078C.464 37.556 0 36.443 0 35.142V6.176c0-1.67.744-3.064 2.88-3.248z",
    fill: "#000"
  }));
};
notion.defaultProps = {
  width: "46",
  height: "49",
  viewBox: "0 0 46 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var office365 = function office365(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#ea3e23",
    d: "M278050 305556l-29-16V28627L178807 0 448 66971l-448 87 22 200227 60865-23821V80555l117920-28193-17 239519L122 267285l178668 65976v73l99231-27462v-316z"
  }));
};
office365.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 278050 333334",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  fillRule: "evenodd",
  clipRule: "evenodd"
};
var remove = function remove(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.555 22.234c5.384 0 9.75-4.365 9.75-9.75 0-5.384-4.366-9.75-9.75-9.75-5.385 0-9.75 4.366-9.75 9.75 0 5.385 4.365 9.75 9.75 9.75zm0 .75c5.799 0 10.5-4.7 10.5-10.5 0-5.799-4.701-10.5-10.5-10.5-5.8 0-10.5 4.701-10.5 10.5 0 5.8 4.7 10.5 10.5 10.5z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.532 15.97L9.071 9.507 9.578 9l6.462 6.462-.508.507z",
    fill: "#E33B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.578 8.857l6.605 6.605-.65.65-6.605-6.604.65-.65zm0 .286l-.365.365 6.32 6.319.364-.365-6.319-6.319z",
    fill: "#E33B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07 15.462L15.533 9l.508.508-6.462 6.461-.507-.507z",
    fill: "#E33B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.532 8.857l.65.65-6.604 6.605-.65-.65 6.604-6.605zm0 .286l-6.319 6.319.365.365 6.319-6.32-.365-.364z",
    fill: "#E33B6B"
  }));
};
remove.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var slack = function slack(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.532 0a5.598 5.598 0 1 0 .002 11.198h5.601V5.6C26.138 2.511 23.63.005 20.532 0c.002 0 .002 0 0 0zm0 14.933H5.601A5.6 5.6 0 0 0 0 20.533c-.005 3.089 2.503 5.596 5.599 5.6h14.933a5.6 5.6 0 1 0 0-11.2z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 20.532a5.6 5.6 0 0 0-5.6-5.599 5.6 5.6 0 0 0-5.602 5.6v5.6H50.4a5.6 5.6 0 0 0 5.601-5.6zm-14.934 0V5.6a5.6 5.6 0 0 0-11.2 0v14.933a5.6 5.6 0 0 0 11.2 0z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.466 56a5.6 5.6 0 0 0 5.6-5.599 5.6 5.6 0 0 0-5.6-5.599h-5.601v5.6c-.002 3.086 2.505 5.593 5.6 5.598zm0-14.936h14.933A5.6 5.6 0 0 0 56 35.466c.005-3.09-2.503-5.597-5.599-5.602H35.468a5.6 5.6 0 0 0-.002 11.2z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.465a5.6 5.6 0 0 0 5.6 5.6 5.6 5.6 0 0 0 5.602-5.6v-5.599H5.6A5.6 5.6 0 0 0 0 35.466zm14.934 0V50.4a5.6 5.6 0 0 0 11.2.002V35.47c.004-3.09-2.504-5.597-5.6-5.601a5.595 5.595 0 0 0-5.6 5.596c0 .003 0 0 0 0z",
    fill: "#E01E5A"
  }));
};
slack.defaultProps = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var outlook = function outlook(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st1", "{", "fill:#0364b8", "}", ".st2", "{", "fill:#0078d4", "}", ".st3", "{", "fill:#28a8ea", "}", ".st10,.st8", "{", "enable-background:new", "}", ".st8", "{", "opacity:.1", "}", ".st10", "{", "opacity:.2", "}"), /*#__PURE__*/React.createElement("path", {
    d: "M512 267.91c.03-4-2.04-7.73-5.45-9.82h-.06l-.21-.12-177.42-105.02c-.77-.52-1.56-.99-2.38-1.42a23.844 23.844 0 0 0-21.84 0c-.82.43-1.62.9-2.38 1.42L124.84 257.96l-.21.12c-5.42 3.37-7.08 10.5-3.71 15.92.99 1.6 2.36 2.93 3.99 3.88L302.32 382.9c.77.51 1.56.99 2.38 1.42a23.844 23.844 0 0 0 21.84 0c.82-.43 1.61-.9 2.38-1.42l177.41-105.02c3.55-2.06 5.71-5.87 5.67-9.97z",
    fill: "#0a2767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.53 197.79h116.43v106.72H145.53V197.79zM488.19 89.3V40.48c.28-12.21-9.38-22.33-21.59-22.62H164.47c-12.21.29-21.87 10.42-21.59 22.62V89.3l178.6 47.63L488.19 89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.88 89.3h119.07v107.16H142.88V89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M381.02 89.3H261.95v107.16l119.07 107.16h107.16V196.47L381.02 89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.95 196.47h119.07v107.16H261.95V196.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.95 303.63h119.07v107.16H261.95V303.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 304.51h116.43v97.02H145.53v-97.02z",
    fill: "#14447d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M381.02 303.63h107.16v107.16H381.02V303.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: "315.534",
    y1: "-877.426",
    x2: "315.534",
    y2: "-651.193",
    gradientTransform: "translate(0 1145.333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#35b8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#28a8ea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M506.55 277.23l-.23.12-177.41 99.78c-.77.48-1.56.93-2.38 1.33a24.703 24.703 0 0 1-9.62 2.38l-9.69-5.67c-.82-.41-1.61-.87-2.38-1.37l-179.8-102.61h-.08l-5.88-3.29v202c.09 13.48 11.09 24.33 24.56 24.24h344.18c.2 0 .38-.1.6-.1 2.85-.18 5.65-.77 8.33-1.74 1.16-.49 2.28-1.07 3.35-1.74.8-.45 2.17-1.44 2.17-1.44 6.1-4.51 9.71-11.64 9.74-19.23V267.91c-.01 3.86-2.1 7.42-5.46 9.32z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.47 267.11v12.38L316.96 407.22 124.9 271.28c0-.07-.05-.12-.12-.12l-17.62-10.6v-8.93l7.26-.12 15.36 8.81.36.12 1.31.83s180.51 103 180.99 103.23l6.91 4.05c.6-.24 1.19-.48 1.91-.71.36-.24 179.2-100.85 179.2-100.85l2.01.12z",
    opacity: ".5",
    fill: "#0a2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.55 277.23l-.23.13-177.41 99.78a24.854 24.854 0 0 1-26.6 0L124.9 277.36l-.21-.13a10.724 10.724 0 0 1-5.61-9.32V469.9c.09 13.47 11.08 24.33 24.55 24.24h343.83c13.47.09 24.47-10.77 24.55-24.24V267.91c-.01 3.86-2.1 7.42-5.46 9.32z",
    fill: "#1490df"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.49 375.67l-2.66 1.49c-.77.49-1.56.94-2.38 1.35a24.645 24.645 0 0 1-9.36 2.48l67.5 79.82 117.75 28.37a24.33 24.33 0 0 0 7.47-9.32L331.49 375.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.52 368.9l-14.68 8.25c-.77.49-1.56.94-2.38 1.35a24.645 24.645 0 0 1-9.36 2.48l31.62 87.19 153.66 20.97A24.064 24.064 0 0 0 512 469.9v-2.61L343.52 368.9z",
    opacity: ".05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.96 494.14h343.46c5.29.03 10.44-1.64 14.7-4.76L307.2 375.2c-.82-.41-1.61-.87-2.38-1.37l-179.8-102.61h-.08l-5.87-3.31v201.3c-.01 13.75 11.13 24.92 24.89 24.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M285.77 134.94v253.98a21.89 21.89 0 0 1-13.69 20.24c-2.56 1.1-5.31 1.67-8.1 1.67H119.07v-285.8h23.81v-11.91h121.09c12.04.04 21.77 9.79 21.8 21.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M273.86 146.85v253.98c.03 2.88-.58 5.72-1.79 8.33a21.701 21.701 0 0 1-20 13.54h-133V125.02h133c3.45-.03 6.86.83 9.88 2.5a21.657 21.657 0 0 1 11.91 19.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M273.86 146.85v230.16c-.06 12.02-9.77 21.77-21.79 21.87h-133V125.02h133c3.45-.03 6.86.83 9.88 2.5a21.657 21.657 0 0 1 11.91 19.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.95 146.85v230.16c-.01 12.04-9.75 21.81-21.79 21.87H119.07V125.02h121.09c12.04.01 21.8 9.77 21.79 21.81v.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: "45.507",
    y1: "-1037.364",
    x2: "216.447",
    y2: "-741.303",
    gradientTransform: "translate(0 1145.333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#1784d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".5",
    stopColor: "#107ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#0a63c9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.83 125.02h218.3c12.05 0 21.83 9.77 21.83 21.83v218.3c0 12.05-9.77 21.83-21.83 21.83H21.83C9.77 386.98 0 377.2 0 365.15v-218.3c0-12.05 9.77-21.83 21.83-21.83z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22 216.56a63.503 63.503 0 0 1 24.93-27.54 75.387 75.387 0 0 1 39.61-9.93 70.147 70.147 0 0 1 36.66 9.42 62.893 62.893 0 0 1 24.25 26.31 84.833 84.833 0 0 1 8.5 38.7 89.623 89.623 0 0 1-8.75 40.48 64.39 64.39 0 0 1-25 27.23 72.935 72.935 0 0 1-38.03 9.67 71.614 71.614 0 0 1-37.47-9.53 64 64 0 0 1-24.58-26.36 82.914 82.914 0 0 1-8.6-38.23 92.12 92.12 0 0 1 8.48-40.22zm26.57 64.66a41.145 41.145 0 0 0 14.03 18.12 36.693 36.693 0 0 0 21.91 6.6 38.38 38.38 0 0 0 23.39-6.81 39.443 39.443 0 0 0 13.62-18.12 70.33 70.33 0 0 0 4.35-25.28c.09-8.7-1.29-17.36-4.1-25.6-2.48-7.44-7.06-14-13.19-18.88a36.21 36.21 0 0 0-23.18-7.14 37.729 37.729 0 0 0-22.42 6.66 41.528 41.528 0 0 0-14.29 18.28 72.645 72.645 0 0 0-.1 52.21l-.02-.04z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.02 89.3h107.16v107.16H381.02V89.3z",
    fill: "#50d9ff"
  }));
};
outlook.defaultProps = {
  id: "Livello_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};
var unverified = function unverified(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.155 1.25l-9.148.042-2.493 3.004L5.89 6.337l2.52 22.77 5.054 4.315 7.572 5.328 7.774-5.285 5.107-4.358 2.52-22.772-7.602-2.003-2.154-3.005-1.526-.077zM14.23 32.472L9.567 28.49 7.216 7.248l6.987-1.871 2.377-2.865 8.547-.04.909.046 2.067 2.884L35.11 7.25l-2.35 21.24-4.661 3.982-7.052 4.794-6.817-4.794z",
    fill: "#AEACC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.125 24.978L15.356 14.21l.846-.846 10.77 10.77-.847.845z",
    fill: "#AEACC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.202 13.125L27.21 24.132l-1.084 1.084L15.118 14.21l1.084-1.084zm0 .476l-.608.608L26.125 24.74l.608-.608-10.53-10.531z",
    fill: "#AEACC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.356 24.132l10.77-10.769.845.846-10.769 10.77-.846-.847z",
    fill: "#AEACC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.125 13.125l1.084 1.084-11.007 11.007-1.084-1.084 11.007-11.007zm0 .476l-10.53 10.531.607.608 10.531-10.53-.608-.61z",
    fill: "#AEACC0"
  }));
};
unverified.defaultProps = {
  width: "41",
  height: "40",
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var verified = function verified(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.174 32.058c-.043 10.868 8.798 19.754 19.805 19.749C38.99 51.8 47.845 42.9 47.814 32.029v-.015l.01-19.819-39.64.02-.01 19.843zM4.013 8.025L4 32.04C3.948 45.268 14.697 56.007 27.982 56c13.284-.007 24.044-10.757 24.006-23.984L52 8l-47.987.025z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.396 38.236L17.77 31.61l.637-.637 5.989 5.989 13.197-13.198.637.637-13.834 13.835z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.396 38.992l-7.383-7.382 1.394-1.394 5.989 5.989 13.197-13.197 1.394 1.393-14.591 14.591zm0-2.03l-5.989-5.99-.637.638 6.626 6.626L38.23 24.4l-.637-.637-13.197 13.198z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.396 38.992l-7.383-7.382 1.394-1.394 5.989 5.989 13.197-13.197 1.394 1.393-14.591 14.591zm0-4.3l13.197-13.198 2.907 2.907-16.104 16.104L15.5 31.61l2.907-2.907 5.989 5.989z",
    fill: "#fff"
  }));
};
verified.defaultProps = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var verifiedGreen = function verifiedGreen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.71 1.25l-9.148.042-2.492 3.004-7.625 2.041 2.52 22.77 5.054 4.315 7.572 5.328 7.774-5.285 5.107-4.358 2.52-22.772-7.602-2.003-2.154-3.005-1.526-.077z",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.742 24.177l-4.97-4.97.479-.477 4.491 4.491 9.898-9.898.478.478-10.376 10.376z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.742 24.744l-5.537-5.537 1.046-1.045 4.491 4.492 9.898-9.898 1.045 1.045-10.943 10.943zm0-1.523l-4.491-4.491-.478.477 4.97 4.97L28.117 13.8l-.478-.478-9.898 9.898z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.742 24.744l-5.537-5.537 1.046-1.045 4.491 4.492 9.898-9.898 1.045 1.045-10.943 10.943zm0-3.225l9.898-9.898 2.18 2.18L17.742 25.88l-6.672-6.672 2.18-2.18 4.492 4.492z",
    fill: "#fff"
  }));
};
verifiedGreen.defaultProps = {
  width: "41",
  height: "40",
  viewBox: "0 0 41 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var xp = function xp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.825 29.19l6.24-9.072 6.146 9.072h6.08l-9.072-12.997L23.84 4h-6.08l-5.63 8.171L6.565 4H.452L9.01 16.225-.062 29.19h5.887zM45.552 12.075c0-2.574-.837-4.568-2.542-5.952C41.338 4.708 39.182 4 36.544 4h-9.362v25.19h5.212v-8.88h3.957c2.767 0 4.986-.707 6.66-2.09 1.704-1.416 2.54-3.475 2.54-6.145zm-5.244.129c0 2.187-1.866 3.249-4.182 3.249h-3.732v-6.53h3.7c2.413 0 4.214.996 4.214 3.28z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.318 36.53h-.004c.245 2.288 2.15 4.058 4.451 4.058 2.3 0 4.207-1.77 4.452-4.058H13.318z",
    fill: "#FFF3D5",
    stroke: "#FFF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 1 0 17.719 36.017)",
    fill: "#FFF3D5",
    stroke: "#FFF3D5",
    strokeWidth: "2.529",
    d: "M1.264 1.264h2.529v33.222H1.264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.203 50.377l.739.758 12.266-12.59-.738-.757-12.267 12.59z",
    fill: "#FFF3D5",
    stroke: "#FFF3D5",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-.98692 1.01291) rotate(45 -48.233 -36.877)",
    fill: "#FFF3D5",
    stroke: "#FFF3D5",
    strokeWidth: "2.529",
    d: "M0 1.811h2.529V20.86H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.287 35.53h4.058v-3.597l-4.058-6.006v9.603z",
    fill: "#FFF3D5",
    stroke: "#FFF3D5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  }))));
};
xp.defaultProps = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const ColoredIcons = {
  activities,
  activityStepCompleted,
  dropbox,
  googleDoc,
  googleCalendar,
  linkedinNegative,
  miro,
  notion,
  remove,
  slack,
  office365,
  outlook,
  unverified,
  verified,
  verifiedGreen,
  xp
};